var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{staticClass:"single-customer-dialog btn-close",attrs:{"title":_vm.dialogTitle,"visible":_vm.dialogVisible,"width":"98%","before-close":_vm.handleClose},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('div',{staticClass:"customer-content",domProps:{"innerHTML":_vm._s(_vm.data)}}),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.handleClose}},[_vm._v("我知道了")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/components/customer/single-customer-dialog.vue?vue&type=template&id=25619d66
// module id = null
// module chunks = 